module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_2_3_5.d487f4d6.png";